<template>
  <v-container
    id="data-tables"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <v-card>
          <template v-slot:after-heading>
            <div
              class="text-h3 font-weight-light"
              style="display: flex;"
            >
              <div>Список получателей </div><v-icon
                medium
                class="icon-table"
                @click="show_header_dialog"
              >
                mdi-table-cog
              </v-icon>
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="headers.filter(a=>a.show || a.active)"
              :items="items"
              multi-sort
              :footer-props="datatable_footer"
              :server-items-length="total"
              :options.sync="table_options"
              :loading="loading"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-text-field
                          v-model="form.search"
                          clearable
                          outlined
                          label="Поиск"
                          prepend-inner-icon="mdi-magnify"
                          dense
                          @keyup.enter="load"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-btn
                          color="primary"
                          outlined
                          @click="filter_dialog = true;"
                        >
                          <v-icon class="ml-3">
                            mdi-filter-variant
                          </v-icon>
                          <span class="mx-3">ФИЛЬТРЫ</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        class="text-right d-none d-md-block"
                        md="6"
                      >
                        <v-btn
                          v-if="$store.state.access[17][5]"
                          color="primary"

                          @click="$router.push('/admin/recipient/create')"
                        >
                          <v-icon class="ml-3">
                            mdi-plus
                          </v-icon>
                          <span class="mx-3">Добавить</span>
                        </v-btn>
                        <v-btn
                          v-if="$store.state.access[17][5]"
                          color="secondary"
                          outlined
                          class="ml-5"
                          @click="report"
                        >
                          <v-icon class="ml-3">
                            mdi-download
                          </v-icon>
                          <span class="mx-3">Выгрузить</span>
                        </v-btn>
                        <v-icon
                          medium
                          class="icon-table"
                          @click="show_header_dialog"
                        >
                          mdi-table-cog
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="12"
                        class="d-md-none"
                      >
                        <v-btn
                          v-if="$store.state.access[17][5]"
                          color="primary"
                          @click="$router.push('/admin/recipient/create')"
                        >
                          <v-icon class="ml-3">
                            mdi-plus
                          </v-icon>
                          <span class="mx-3">Добавить</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        class="d-md-none"
                      >
                        <v-btn
                          v-if="$store.state.access[17][5]"
                          color="secondary"
                          outlined
                          @click="report"
                        >
                          <v-icon class="ml-3">
                            mdi-download
                          </v-icon>
                          <span class="mx-3">Выгрузить</span>
                        </v-btn>
                      </v-col>
                      <!-- Icon -->
                      <v-col
                        cols="12"
                        class="d-md-none"
                      >
                        <v-icon
                          medium
                          class="icon-table"
                          @click="show_header_dialog"
                        >
                          mdi-table-cog
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="12"
                        class="mt-n5"
                      >
                        <div v-if="filter.set">
                          <div
                            v-for="(tab, index) in filter_fields"
                            :key="'tab_f' + index"
                          >
                            <v-chip
                              v-for="(filter, index2) in tab.data.filter(a=>a.value ||a.value ===0 || a.from || a.to || a.max || a.min)"
                              :key="'data_f' + index2"
                              color="grey lighten-2"
                              class="ma-1"
                              close
                              @click:close="clear_filter_value(filter)"
                            >
                              <span v-if="filter.type == 'date'">{{ filter.name }}: {{ format(filter.from) }}/{{ format(filter.to) }}</span>
                              <span v-else-if="filter.type == 'select'">{{ filter.name }}: {{ filter.select.filter(a=>a.value == filter.value)[0].text }}</span>
                              <span v-else>{{ filter.name }}: {{ filter.value }}</span>
                            </v-chip>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.state="{item}">
                <v-chip :color="get_state_color(item.state)">
                  {{ dict.state[item.state] }}
                </v-chip>
              </template>
              <template v-slot:item.action="{ item }">
                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="100"
                  :nudge-bottom="12"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs, value }">
                    <v-btn
                      v-bind="attrs"
                      color="primary"
                      text
                      v-on="on"
                      @click="sheetitem = item"
                    >
                      <v-icon
                        large
                        class="beg_triangle"
                      >
                        mdi-menu-open
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-list>
                      <v-list-item @click="$router.push('/admin/recipient/view?id=' + sheetitem.id)">
                        <v-list-item-content>
                          Открыть
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="$store.state.access[17][3] || $store.state.access[17][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id"
                        @click="$router.push('/admin/recipient/change?id=' + sheetitem.id)"
                      >
                        <v-list-item-content>
                          Изменить
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="$store.state.access[17][3] || $store.state.access[17][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id"
                        @click="DeleteItem(sheetitem)"
                      >
                        <v-list-item-content>
                          Удалить
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </template>
              <template v-slot:item.name="{item}">
                <span v-if="item">
                  {{ item.surname }} {{ item.name }} {{ item.patronymic }}
                </span>
              </template>
              <template v-slot:item.phones="{item}">
                <div v-if="item.phones && item.phones.length > 0">
                  <span
                    v-for="(phone, index) in item.phones"
                    :key="index"
                  >
                    {{ phone.number }}<br>
                  </span>
                </div>
              </template>
              <template v-slot:item.updated="{ item }">
                <span v-if="item && item.updated">
                  {{ format_date(item.updated) }}
                </span>
              </template>
              <template v-slot:item.name="{item}">
                <span v-if="item">
                  {{ item.surname }} {{ item.name }} {{ item.patronymic }}
                </span>
              </template>
              <template v-slot:item.phones="{item}">
                <div v-if="item.phones && item.phones.length > 0">
                  <span
                    v-for="(phone, index) in item.phones"
                    :key="index"
                  >
                    {{ phone.number }}<br>
                  </span>
                </div>
              </template>
              <template v-slot:item.created="{ item }">
                <span v-if="item && item.created">
                  {{ format_date(item.created) }}
                </span>
              </template>
              <template v-slot:item.balance="{item}">
                <v-chip color="blue">
                  {{ item.balance || 1000 }}
                </v-chip>
              </template>
              <template v-slot:item.modules="{item}">
                Вендинговый аппарат
              </template>
              <template v-slot:item.legal.address_legal="{item}">
                <span v-if="item.addresses && item.addresses.filter(a=>a.type == 1)[0]">
                  {{ item.addresses.filter(a=>a.type == 1)[0].value }}
                </span>
              </template>
              <template v-slot:item.legal.address_fact="{item}">
                <span v-if="item.addresses && item.addresses.filter(a=>a.type == 2)[0]">
                  {{ item.addresses.filter(a=>a.type == 2)[0].value }}
                </span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <v-bottom-sheet v-model="sheet">
          <v-list>
            <v-list-group v-model="sheetmenu">
              <v-list-tile slot="activator">
                <v-list-tile-action>
                  <v-icon>mdi-build</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Действия</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-item @click="$router.push('/admin/recipient/view?id=' + sheetitem.id)">
                <v-list-item-content>
                  Открыть
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="$store.state.access[17][3] || $store.state.access[17][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id"
                @click="$router.push('/admin/recipient/change?id=' + sheetitem.id)"
              >
                <v-list-item-content>
                  Изменить
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="$store.state.access[17][3] || $store.state.access[17][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id"
                @click="DeleteItem(sheetitem)"
              >
                <v-list-item-content>
                  Удалить
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-bottom-sheet>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="filter_dialog"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-filter-outline"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="text-h5">Фильтры</span>
          </v-card-title>
          <v-card-text>
            <v-tabs
              v-model="tab_index"
              vertical
            >
              <v-tab
                v-for="(tab, index) in filter_fields"
                :key="index"
              >
                <div class="filter_row">
                  {{ tab.name }}
                  <v-btn
                    icon
                    @click="setFavouriteTab(tab.index)"
                  >
                    <v-icon
                      left
                      :class="[{'active': $store.state.user.tab_recipient == tab.index}]"
                    >
                      mdi-star
                    </v-icon>
                  </v-btn>
                </div>
              </v-tab>

              <v-tab-item
                v-for="(tab, index) in filter_fields"
                :key="index"
              >
                <v-card flat>
                  <v-card-text>
                    <div
                      v-for="(field, index2) in tab.data"
                      :key="'i_'+index2"
                    >
                      <v-select
                        v-if="field.type=='select'"
                        v-model="field.value"
                        clearable
                        :label="field.name"
                        :items="field.select"
                        @change="filter.changed = true"
                      />
                      <div
                        v-else-if="field.type=='date'"
                        clearable
                        :label="field.name"
                        :items="field.select"
                      >
                        <v-row>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-select
                              v-model="field.date_select"
                              clearable
                              :label="field.name"
                              :items="[{value:'yesterday', text:'Вчера'},{value:'today', text:'Сегодня'},{value:'tomorrow', text:'Завтра'},{value:'date', text:'Конкретная дата'},{value:'period', text:'Период дат'}]"
                              @change="changeFilterDateType($event, index , field)"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="field.from"
                              :label="field.date_select == 'period' ? 'От' : 'Конкретная дата'"
                              :disabled="field.date_select !== 'period' && field.date_select !== 'date'"
                              type="date"
                              :max="max_date"
                              @input="filter.changed = true"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-if="field.date_select == 'period'"
                              v-model="field.to"
                              label="До"
                              type="date"
                              :max="max_date"
                              @input="filter.changed = true"
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <v-text-field
                        v-else
                        v-model="field.value"
                        :label="field.name"
                        :type="field.type"
                        @input="filter.changed = true"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="filter_dialog = false, set_filter()"
            >
              <span class="mx-10">Применить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="filter_dialog = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
      <v-dialog
        v-model="dialog.headers.show"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-table-cog"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="text-h5">Настройка столбцов</span>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :items-per-page="5"
              dense
              :items="headers.filter(a=>!a.show)"
              :headers="[{value: 'text', text: 'Название столбца'}, {value: 'active_temp', text: 'Отображение'}]"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:item.active_temp="{item}">
                <v-checkbox v-model="item.active_temp" />
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="dialog.headers.show = false, set_headers()"
            >
              <span class="mx-10">Сохранить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="dialog.headers.show = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<style lang="scss">
.icon-filter {
  color: grey;
  &.active {
    color:orange;
  }
  &:not(.active):hover {
    color: #315bbf;
  }
}
.icon-magnify {
  color: rgb(121, 114, 118);
  &:hover {
    color: #315bbf;
  }
}
.icon-table {
  height: 30px;
  width: 30px;
  margin-top: 3px;
  margin-left: 8px;
  color: grey;
  &:hover {
    color: #315bbf;
  }
}
.btns-edit-group {
  height: 36px!important;
  .beg_pencil {
    background-color: rgb(0, 143, 203)!important;
    border-color: rgb(24, 123, 154)!important;
    color: white;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    min-width: 50px!important;
    width: 50px!important;
    height: 36px!important;
  }
  .beg_select {
    background-color: rgb(0, 143, 203)!important;
    border-color: rgb(24, 123, 154)!important;
    color: white;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    min-width: 30px!important;
    width: 30px!important;
    height: 36px!important;

    .beg_triangle {
      transform: scale(0.36,0.22) rotate(180deg);
    }
    &.active {
      .beg_triangle {
        transform: scale(0.36,0.22) rotate(0deg);
      }
    }
  }
  .v-btn__content,
  i {
    height: 36px!important;
  }
}
/**popup */
.filter_popup .v-tabs--vertical > .v-tabs-bar .v-tab {
  display: flex;
  flex-direction: column;
  height: 80px;
  width: 140px;
  font-size: 0.6rem !important;
  line-height: 0.8rem;
  white-space: pre-wrap;
  .filter_row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .v-btn {
      height: 30px;
      width: 30px;
      margin-right: -15px;
      &:hover {
        .v-icon {
          color: rgba(0, 0, 0, 0.1);
        }
      }
      .v-icon {
        margin: 0px;
        color: rgba(0, 0, 0, 0.01);
        &.active {
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }
}
@media (min-width: 960px) {
  .filter_popup .v-tabs--vertical > .v-tabs-bar .v-tab {
    flex-direction: row;
    height: 54px;
    width: 180px;
    font-size: 0.70rem !important;
    line-height: 0.8rem;
    white-space: pre-wrap;
    .filter_row {
      .v-btn {
        margin-left: 10px;
      }
    }
  }
}
/** _popup */

.search-row {
  display: flex;
  flex-direction: row;
}
.search-title {
  padding-top: 24px;
  padding-right: 10px;
  margin-top: 4px;
  font-size: 1.6rem;
  color: #ec7e2f;
}
.table_item {
  font-size: 0.929rem;
  padding-bottom: 12px;
}
.table_item:first-of-type {
  padding-top: 12px;
}

.table_item__title {
  font-size: 0.929rem;
}
.table_item__subtitle {
  font-size: 0.875rem;
  line-height: 1.2;
  color: #999;
}
</style>
<script>
  import suggest from '../../libs/suggestions.min.17.12.0.dev.js'
  import moment from 'moment'
  import $ from 'jquery'
import { truncate } from 'fs'
import { parse } from 'path'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      table_options: {

      },
      total: 0,
      loading: false,
      tab_index: 0,
      dialog: {
        headers: {
          show: false
        }
      },
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      sheet: false,
      sheetmenu: true,
      sheetitem: {},
      headers: [
        {
          text: 'Действия',
          value: 'action',
          show: true
        },
        {
          text: 'Дата регистрации',
          value: 'created',
          active: true,
          active_temp: false
        },
        {
          text: 'Номер',
          value: 'number',
          active: true,
          active_temp: false
        },
        {
          text: 'Юридическое название',
          value: 'legal.name.short',
          active: true,
          active_temp: false
        },
        {
          text: 'Полное наименование',
          value: 'legal.name.full',
          active: false,
          active_temp: false
        },
        {
          text: 'ОГРН',
          value: 'legal.ogrn',
          active: false,
          active_temp: false
        },
        {
          text: 'ИНН',
          value: 'legal.inn',
          active: false,
          active_temp: false
        },
        {
          text: 'КПП',
          value: 'legal.kpp',
          active: false,
          active_temp: false
        },
        {
          text: 'Должность руководителя',
          value: 'legal.director.post',
          active: false,
          active_temp: false
        },
        {
          text: 'ФИО руководителя',
          value: 'legal.director.name',
          active: false,
          active_temp: false
        },
        {
          text: 'Адрес юридический',
          value: 'legal.address_legal',
          active: false,
          active_temp: false
        },
        {
          text: 'Адрес фактический',
          value: 'legal.address_fact',
          active: false,
          active_temp: false
        },
        {
          text: 'Телефон',
          value: 'phones'
        },
        {
          text: 'Наименование банка',
          value: 'requisites.bank_name'
        },
        {
          text: 'Расчетный счет',
          value: 'requisites.rs'
        }
      ],
      doc_type: {

      },
      items: [],
      form: {

      },
      search: "",
      select: {
      },
      dict: {
        state: {
          0: 'Доступен',
          1: 'Недоступен'
        }
      },
      filter_dialog: false,
      filter_fields: {
        common: {
          index: 0,
          name: "Основное",
          active: true,
          data: [
            {
              name: "Наименование",
              data: "name",
              type: "text",
            },
            {
              name: "Номер",
              data: "number",
              type: "text",
            },
            {
              name: "Дата создания",
              data: "created",
              type: "date",
            },
          ]
        }
      },
      filter: {
        set: false
      },
      entity: 'admin.recipient'
    }),
    computed: {
      max_date: function () {
        return moment().format('YYYY-MM-DD')
      },
    },
    watch: {
      table_options: {
        handler () {
          console.log(this.table_options)
          this.$router.push({
            query: {
              page: this.table_options.page,
              limit: this.table_options.itemsPerPage
            }
          })
          this.load()
        },
        deep: true,
      },
    },
    beforeRouteEnter (to, from, next) {
      localStorage.removeItem('admin.client')
      localStorage.removeItem('admin.configuration')
      localStorage.removeItem('admin.device')
      localStorage.removeItem('admin.member')
      localStorage.removeItem('admin.equipment')
      localStorage.removeItem('admin.event')
      localStorage.removeItem('admin.fiscal')
      localStorage.removeItem('admin.item')
      localStorage.removeItem('admin.kkt')
      localStorage.removeItem('admin.operator')
      localStorage.removeItem('admin.place')
      localStorage.removeItem('admin.point')
      localStorage.removeItem('admin.role')
      localStorage.removeItem('admin.user')
      localStorage.removeItem('admin.sbpbank')
      localStorage.removeItem('admin.sbpprofile')
      localStorage.removeItem('admin.nomenclature')
      localStorage.removeItem('admin.category')
      localStorage.removeItem('admin.order')
      localStorage.removeItem('admin.payment')
      next()
    },
    mounted: function () {
      if (this.$route.query.id) {
        this.form.id = this.$route.query.id
      } else {
        const filter = localStorage.getItem(this.entity)
        if (filter) {
          this.filter_fields = JSON.parse(filter)
          this.filter.set = true
          this.filter.changed = false
        }
      }
      if (this.$route.query.page) {
        this.table_options.page = Number(this.$route.query.page)
        this.table_options.itemsPerPage = Number(this.$route.query.limit)
      }
      for (const x in this.$store.state.dict.doc_type) {
        if (this.$store.state.dict.doc_type[x].type) {
          this.doc_type[this.$store.state.dict.doc_type[x].type] = Number(x)
          for (const y in this.filter_fields.documents.data) {
            if (this.filter_fields.documents.data[y].key == this.$store.state.dict.doc_type[x].type) {
              this.filter_fields.documents.data[y].extra = { data: 'type', value: Number(x) }
            }
          }
        }
      }
      this.tab_index = this.$store.state.user.tab_recipient
      this.load()
      this.set_default_headers()
    },
    methods: {
      set_default_headers: function () {
          if (!this.$store.state.user.recipient_headers || this.$store.state.user.recipient_headers.length == 0) return
          for (const x in this.headers) {
            this.headers[x].active = this.$store.state.user.recipient_headers.indexOf(this.headers[x].value) > -1
          }
      },
      clear_filter_value: function (field) {
        field.value = ''
        field.from = ''
        field.to = ''
        field.date_select = ''
         field.min = ''
        field.max = ''
        this.filter.changed = true
        this.set_filter()
      },
      report: function () {
        const request = JSON.parse(JSON.stringify(this.form))
        if (this.filter.set) {
          request.data = JSON.parse(JSON.stringify(this.filter_fields))
          delete request.data.set
          delete request.data.changed
        }
        request.headers = this.headers.filter(a => a.active == true).map(a => a.value)
        const form = $('<form>', {
            target: '_blank',
            action: '/api/recipient/export?token=' + localStorage.getItem("token"),
            method: 'post',
          })
          form.append(
            $('<input>', {
              type: 'hidden',
              value: JSON.stringify(request),
              name: 'form',
            })
          )
          form.appendTo('body').submit()
      },
      get_state_color: function (state) {
        if (state == 0) return 'green'
        if (state == 1) return 'yellow'
      },
      accept: function (item) {
        item.state = 1
          this.axios.post('/api/recipient/save', item)
            .then(result => {
              this.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Успешно')
                this.load()
              } else {
                this.$store.commit('snackbar', 'Ошибка при сохранении')
              }
            })
            .catch(error => {
              this.loading = false
              this.$store.commit('snackbar', 'Ошибка при сохранении')
            })
      },
      setFavouriteTab: function (index) {
        this.axios.post('/api/user/favourite_tab', { value: index, type: 'tab_recipient' })
          .then(result => {
            if (!result.data.error) {
              this.$store.commit('SET_FAVOURITE_TAB', { value: index, type: 'tab_recipient' })
            }
          })
          .catch(e => {
          })
      },
      DeleteItem: function (item) {
        this.sheet = false
        if (confirm('Вы уверены?')) {
          item.deleted = true
          this.axios.post('/api/recipient/save', item)
            .then(result => {
              this.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Удаление успешно')
                this.load()
              } else {
                this.$store.commit('snackbar', 'Ошибка при удалении')
              }
            })
            .catch(error => {
              this.loading = false
              this.$store.commit('snackbar', 'Ошибка при удалении')
            })
        }
      },
      show_header_dialog: function () {
        for (const x in this.headers) {
          this.headers[x].active_temp = this.headers[x].active
        }
        this.dialog.headers.show = true
      },
      set_headers: function () {
        for (const x in this.headers) {
          this.headers[x].active = this.headers[x].active_temp
        }
        this.$axios.post('/api/user/headers', {
          entity: 'recipient',
          headers: this.headers.filter(a => a.active).map(a => a.value)
        })
        .catch(e => {
          console.log(e)
        })
      },
      fill_dict: function (data, dict) {
        data.select = []
        for (const x in dict) {
          data.select.push({ value: Number(x), text: dict[x].name })
        }
      },
      set_filter: function (flag) {
        if (this.filter.changed) this.filter.set = true
        this.filter.changed = false
        this.load()
        localStorage.setItem(this.entity, JSON.stringify(this.filter_fields))
      },
      clear_filter: function () {
        this.filter.set = false
        for (const x in this.filter_fields) {
          for (const y in this.filter_fields[x].data) {
             this.filter_fields[x].data[y].value = ''
             this.filter_fields[x].data[y].from = ''
             this.filter_fields[x].data[y].to = ''
          }
        }
        localStorage.removeItem(this.entity)
      },
      formatInputDate: function (_date) {
        const date = new Date(_date)
        let dd = date.getDate()
        if (dd < 10) dd = '0' + dd

        let mm = date.getMonth() + 1
        if (mm < 10) mm = '0' + mm

        let yyyy = date.getFullYear()
        if (yyyy < 10) yyyy = '0' + yyyy

        return yyyy + '-' + mm + '-' + dd
      },
      changeFilterDateType (value, tab, field) {
        this.filter.changed = true
        console.log('changeFilterDateType', value, tab, field)
        if (tab && field && value) {
          if (value !== 'period' && value !== 'date') {
            let date = 0
            if (value == 'today') {
              date = new Date()
            } else if (value == 'yesterday') {
              date = new Date().setDate(new Date().getDate() - 1)
            } else if (value == 'tomorrow') {
              date = new Date().setDate(new Date().getDate() + 1)
            }
            const formated_date = this.formatInputDate(date)
            field.from = formated_date
            field.to = formated_date
          }
          if (value == 'date') {
            field.to = ''
          }
        }
      },
      format_date: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      getDoc: function (item) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      clear: function () {
        this.form = {
        },
        this.load()
      },
      load: function (clear) {
        const request = JSON.parse(JSON.stringify(this.form))
        if (this.filter.set) {
          request.data = JSON.parse(JSON.stringify(this.filter_fields))
          delete request.data.set
          delete request.data.changed
        }
        this.loading = true
        const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
        request.page = page
        request.limit = itemsPerPage
        this.axios.post('/api/recipient/list', request)
          .then(result => {
             this.loading = false
            this.form.id = null
            if (!result.data.error) {
              this.items = result.data.data
              this.total = result.data.count
            }
          })
          .catch(e => {
             this.loading = false
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    },
  }
</script>
